export default __webpack_public_path__ + "static/media/230.d1099317.jpg";